import React from 'react';
import { RouteObject } from 'react-router-dom';
import { useLocation } from 'react-router';
import { isFeatureEnabled } from 'ff/common/ffAppUtils';

import Fade from '@mui/material/Fade';

import MapGridLayout from 'ff/debrief/layouts/MapGridLayout';
import DebriefMapControls from 'ff/debrief/components/map/DebriefMapControls';
import ErrorBar from 'ff/debrief/components/ErrorBar';
import Timeline from 'ff/debrief/components/timeline';
import DebriefSidebar from 'ff/debrief/components/debriefSidebar/DebriefSidebar';
import Instruments from 'ff/debrief/components/instruments';
import SegmentDetails from 'ff/debrief/components/scoringDetails/SegmentDetails';
import { useDebriefApp } from 'ff/debrief/hooks';
import { LinkToShared, LinkToTracklog } from 'ff/debrief/router';
import ProcessingStatusToast from 'ff/debrief/components/details/ProcessingStatusToast';
import VspeedAlert from 'ff/debrief/components/VspeedAlert';
import { RouteProvider } from 'ff/debrief/router/RouteContext';

export const pathString = '/:tracklogId?/debrief';

const DebriefRoute = () => {
    const { isChartOpen } = useDebriefApp();

    const isFromShared = useLocation().state?.isFromShared;
    const returnLink = isFromShared ? LinkToShared : LinkToTracklog;

    return (
        <RouteProvider isFromShared={isFromShared}>
            <MapGridLayout withOwnship>
                <VspeedAlert />
                <DebriefMapControls />
                <DebriefSidebar returnLink={returnLink} />
                <Timeline />
                <ErrorBar />
                <Fade in={isChartOpen} unmountOnExit>
                    <SegmentDetails />
                </Fade>
                <ProcessingStatusToast />
                {isFeatureEnabled('debrief_features') && <Instruments />}
            </MapGridLayout>
        </RouteProvider>
    );
};

const route: RouteObject = {
    path: pathString,
    element: <DebriefRoute />,
};

export default route;
